import { render, staticRenderFns } from "./AnnouncementItem.vue?vue&type=template&id=4109d7a2&scoped=true"
import script from "./AnnouncementItem.vue?vue&type=script&lang=js"
export * from "./AnnouncementItem.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementItem.vue?vue&type=style&index=0&id=4109d7a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4109d7a2",
  null
  
)

export default component.exports